// extracted by mini-css-extract-plugin
module.exports = {"request-detail":"j_BU2"};